<template>
	<section class="section-base form-section-base">
		<div class="form-section-base__block-outer">
			<div class="form-section-base__block-inner">
				<div class="form-section-base__title">Сведения о должнике</div>
				<div class="form-section-base__controls">
					<v-row>
						<v-col>
							<v-radio-group v-model="role" row :disabled="isSurcharge">
								<v-radio label="Физическое лицо" :value="Role.PERSON"/>
								<v-radio label="Юридическое лицо" :value="Role.ORGANIZATION"/>
								<v-radio
									label="Иностранное юридическое лицо"
									:value="Role.FOREIGN_ORGANIZATION"
								/>
							</v-radio-group>
						</v-col>
					</v-row>
				</div>

				<Person
					v-if="role === Role.PERSON"
					:v="$v.person"
					:key="1"
					:disabled="isSurcharge"
					translationKey="noticeRecovery.debtor.person"
				/>

				<Organization
					v-if="role === Role.ORGANIZATION"
					:v="$v.organization"
					:key="2"
					:disabled="isSurcharge"
					translationKey="noticeRecovery.debtor.org"
				/>

				<ForeignOrganization
					v-if="role === Role.FOREIGN_ORGANIZATION"
					:v="$v.foreignOrganization"
					:key="3"
					:disabled="isSurcharge"
					translationKey="noticeRecovery.debtor.foreignOrg"
				/>
			</div>
		</div>
		<v-container>
			<Footer
				@next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
				@prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
				:loading-next="loadingNext"
			/>
		</v-container>
	</section>
</template>

<script>
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';

import {checkInvalid, leaveStep} from '@/utils/services';
import {Role, JobPlaceDictionary} from '@/utils/dictionaries';
import {ServicesModule} from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import {StepDirection, StepName} from '@/types/services';
import Person, {personModel, getPersonValidation} from './Person';
import Organization, {
	organizationModel,
	organizationValidation,
} from './Organization';
import ForeignOrganization, {
	foreignOrganizationModel,
	foreignOrganizationValidation,
} from './ForeignOrganization';
import {NoticeRecoveryStep} from '@/constants';

export default {
	name: 'Debtor',
	props: {
		loadingNext: {
			type: Boolean,
			required: true,
		},
		isSurcharge: {
			type: Boolean,
			required: true,
		},
	},
	components: {
		Person,
		Organization,
		ForeignOrganization,
		Footer,
	},
	data: () => ({
		StepDirection,
		StepName,
		leaveStep,
		Role,
		invalidFields: [],
		role: Role.PERSON,
		person: cloneDeep(personModel),
		organization: cloneDeep(organizationModel),
		foreignOrganization: cloneDeep(foreignOrganizationModel),
	}),
	validations() {
		return {
			person: getPersonValidation(this.person),
			organization: cloneDeep(organizationValidation),
			foreignOrganization: cloneDeep(foreignOrganizationValidation),
		};
	},
	created() {
		this.prefillDraft();
	},
	methods: {
		prefillDraft() {
			if (!ServicesModule.statement.subjects.debtor) {
				return;
			}

			const debtorStore = cloneDeep(ServicesModule.statement.subjects.debtor);

			if (debtorStore.person) {
				this.role = Role.PERSON;
				this.person = deepmerge(personModel, debtorStore.person);

				if (debtorStore.identityDocument) {
					this.person.identityDocument = deepmerge(
						personModel.identityDocument,
						debtorStore.identityDocument
					);
				}

				if (debtorStore.jobPlace) {
					if (debtorStore.jobPlace.orgName) {
						this.person.jobPlaceSelect = JobPlaceDictionary.ORGANIZATION;
						this.person.jobPlace[JobPlaceDictionary.ORGANIZATION] = deepmerge(
							personModel.jobPlace[JobPlaceDictionary.ORGANIZATION],
							debtorStore.jobPlace
						);
					} else {
						this.person.jobPlaceSelect = JobPlaceDictionary.BUSINESSMAN;
						this.person.jobPlace[JobPlaceDictionary.BUSINESSMAN] = deepmerge(
							personModel.jobPlace[JobPlaceDictionary.BUSINESSMAN],
							debtorStore.jobPlace
						);
					}
				} else if (debtorStore.person.isBusinessman) {
					this.person.jobPlaceSelect = JobPlaceDictionary.IS_BUSINESSMAN;
				} else {
					this.person.jobPlaceSelect = JobPlaceDictionary.WORK_UNKNOWN;
				}
			}

			if (debtorStore.organization) {
				this.role = Role.ORGANIZATION;
				this.organization = cloneDeep(debtorStore.organization);
			}

			if (debtorStore.foreignOrganization) {
				this.role = Role.FOREIGN_ORGANIZATION;
				this.foreignOrganization = cloneDeep(debtorStore.foreignOrganization);
			}
		},

		touchFields() {
			this.invalidFields = [];
			this.$v[this.role].$touch();
			checkInvalid(this.$v[this.role], this.invalidFields);
		},

		assemblyModel() {
			const debtor = {
				[this.role]: cloneDeep(this[this.role]),
			};

			if (this.role === Role.PERSON) {
				delete debtor[Role.PERSON].jobPlace;
				delete debtor[Role.PERSON].identityDocument;
				delete debtor[Role.PERSON].jobPlaceSelect;

				const debtorJobPlaces = [
					JobPlaceDictionary.BUSINESSMAN,
					JobPlaceDictionary.ORGANIZATION,
				];

				if (debtorJobPlaces.includes(this.person.jobPlaceSelect)) {
					debtor.jobPlace = cloneDeep(
						this.person.jobPlace[this.person.jobPlaceSelect]
					);
				}

				debtor.person.isBusinessman =
					this.person.jobPlaceSelect === JobPlaceDictionary.IS_BUSINESSMAN;

				if (!debtor.person.isBusinessman) {
					debtor.person.ogrn = null;
					debtor.person.regDate = null;
					debtor.person.emailUl = null;
					debtor.person.regPlace = null;
				}

				debtor.identityDocument = cloneDeep(this.person.identityDocument);
			}

			return debtor;
		},
		btnSaveClickHandler(direction) {
			leaveStep({
				stepThis: this,
				direction,
				step: NoticeRecoveryStep.DEBTOR,
			});
		},
	},
};
</script>

<style scoped></style>
